export enum CDN {
    S3 = "https://r3z-test-eu.s3.eu-west-1.amazonaws.com/",
    CDN1 = "https://d3vuqzsqy1r5zj.cloudfront.net/",
    CDN2 = "https://e43e8e18e725ae6b22e0-f0fde0bbc5469096ab6f7c4eba4934a9.ssl.cf3.rackcdn.com/",
    CDN3 = "https://cdn3.rezonence.com/"
}
